import { last, first, get, chunk, isEmpty } from 'lodash'
import { RouterView } from 'vue-router'
import { FuxiApolloSdk } from '@didi/fuxi-sdk'
// import { FuxiApolloSdk } from '/Users/didi/Documents/soda-code/fuxi-sdk/'
import { trackEvent } from '@/plugins/plugin-init-omega'
import { showUpdateInfo } from '@/utils/cache-opt'
import router from '@/router'
import {
  FUXI_ENV,
  APP_KEYS,
  BASE_SIM_APP_KEYS,
  APPKEY_PREFIX,
  BASE_SIM_FLAG,
  fuxiComponents,
} from './config'
import { IS_SIM } from '@/config/constants'

const FUXI_CACHE_KEY = `FUXI_CACHE_${FUXI_ENV}`

let apps_obtain_start_time = null
let apps_obtain_end_time = null

export async function initLowCode() {
  try {
    const appsInfo = await getAppsInfo()
    const routes = []
    Object.keys(appsInfo).forEach(app => {
      const appInfo = appsInfo[app]
      const route = formatAppToRoute(appInfo)
      route && routes.push(route)
    })
    routes.forEach(route => {
      router.addRoute(route)
    })
    console.info('log => initLowCode appsInfo', appsInfo)
    console.info('log => initLowCode routes', routes)
  } catch (error) {
    console.warn(error)
    trackEvent('tech_gattaran_lowcode_apps_info_error_st', '低码应用菜单转路由配置失败', {
      error,
    })
  }
}
// 分块获取低码应用配置
const chunkGetAppInfo = async (keys, chunkNum = 10) => {
  const getAllAppInfo = async () => {
    const result = await Promise.all(
      chunk(keys, chunkNum).map((keys, index) => {
        return new FuxiApolloSdk().init({
          env: FUXI_ENV,
          appKeys: keys,
          uniqueKey: `chunk_${index}`,
          _timeout: 10000,
        })
      }),
    )
    return result.reduce((prev, current) => {
      Object.assign(prev, current)
      return prev
    }, {})
  }
  // 取缓存的配置
  const cachedInfoObj = JSON.parse(localStorage.getItem(FUXI_CACHE_KEY) || '{}')
  if (hitCache(keys, cachedInfoObj)) {
    // 异步获取获取新增的配置，并存储到本地
    getAllAppInfo().then(res => {
      // 判断
      const _isSames = isSame(res, cachedInfoObj)
      console.log('log => _isSames', _isSames)
      if (!isEmpty(cachedInfoObj) && !_isSames && isLowcodePage()) {
        showUpdateInfo('低码应用配置有更新')
      }
      localStorage.setItem(FUXI_CACHE_KEY, JSON.stringify(res))
    })
    return cachedInfoObj
  }
  return getAllAppInfo()
}
async function getAppsInfo() {
  let appsInfo
  try {
    const IS_SIM_UNBASE = IS_SIM && !APPKEY_PREFIX.includes(BASE_SIM_FLAG)
    apps_obtain_start_time = new Date().getTime()
    if (IS_SIM_UNBASE) {
      appsInfo = await chunkGetAppInfo(APP_KEYS.concat(BASE_SIM_APP_KEYS))
    } else {
      appsInfo = await chunkGetAppInfo(APP_KEYS)
    }
    apps_obtain_end_time = new Date().getTime()
    trackEvent('tech_gattaran_lowcode_apps_info_success_st', '低码应用配置获取成功', {
      config: APP_KEYS,
      time:
        apps_obtain_start_time && apps_obtain_end_time
          ? apps_obtain_end_time - apps_obtain_start_time
          : null,
    })
    // sim环境下实现低码配置的流量穿梭
    if (IS_SIM_UNBASE) {
      APP_KEYS.forEach(key => {
        if (appsInfo[key]) {
          const BASE_SIM_APP_KEY = key.replace(/sim\d+/, BASE_SIM_FLAG)
          delete appsInfo[BASE_SIM_APP_KEY]
        }
      })
    }
    // 缓存本地用于接口失败降级
    localStorage.setItem(FUXI_CACHE_KEY, JSON.stringify(appsInfo))
  } catch (err) {
    console.error(err)
    trackEvent('gattaran_lowcode_page_fuxi_sdk_init_error_bt', '低码应用配置获取失败', {
      error: err,
    })
    // sdk 获取失败降级从local获取配置
    appsInfo = localStorage.getItem(FUXI_CACHE_KEY) || '{}'
    appsInfo = JSON.parse(appsInfo)
  }
  return appsInfo
}
function parseMeta(meta) {
  const metaMap = {}
  if (meta && Array.isArray(meta)) {
    meta.forEach(({ key, value }) => {
      // meta的值支持配置为json字符串，在此处进行解析
      try {
        value = JSON.parse(value)
      } catch (error) {
        console.warn('meta值解析失败，请确实是否为正确JSON字符串', value)
      }
      metaMap[key] = value
    })
  }
  return metaMap
}
function getRouteComponent({ type, pageId, path }) {
  if (pageId && fuxiComponents[type]) {
    const comp = fuxiComponents[type]
    return {
      name: `${comp.name}_${pageId}_${path}`,
      ...comp,
    }
  }
  return {
    render(h) {
      return h(RouterView)
    },
  }
}
function formatAppToRoute(info) {
  const _base = get(info, 'basic.base', null)
  if (!_base) return null
  const base = '/' + _base
  const route = []
  // 路由的路径栈，用于生成redirect
  const pathStack = [base]
  const currentRoute = [route]
  const setRedirect = routeConfig => {
    // 配置了重定向或叶子节点无需自定配置重定向
    if (routeConfig.redirect || routeConfig.children.length === 0) return
    const firstChildren = first(routeConfig.children)
    pathStack.push(firstChildren?.path)
    routeConfig.redirect = pathStack.join('/')
    pathStack.pop()
  }
  // 菜单转路由配置
  const menuToRouterConfig = menu => {
    const { type, redirect = '', url, pageId, name, path, menuRender, meta } = menu
    const metaMap = parseMeta(meta)
    const pageInfo = info.pageMaps[pageId]
    const fullPath = pathStack.join('/')
    return {
      path,
      name: fullPath, // gattarn中菜单使用路由的name跳转,需配置name为fullpath
      ...(redirect ? { redirect } : {}),
      props: {
        url,
        assetsUrl: get(pageInfo, 'lastRelease.assetsProUrl'),
        schemaUrl: get(pageInfo, 'lastRelease.schemaUrl'),
      },
      meta: {
        pageID: pageId,
        title: name,
        // GTR中menuRender控制是否渲染侧边栏menu
        menuRender: !!menuRender,
        ...metaMap,
      },
      component: getRouteComponent({ type, pageId, path }),
      children: [],
    }
  }
  const loopMenus = menus => {
    const current = last(currentRoute)
    menus.forEach(menu => {
      pathStack.push(menu.path)
      const routeConfig = menuToRouterConfig(menu)
      current.push(routeConfig)
      if (menu.children && menu.children.length) {
        currentRoute.push(routeConfig.children)
        loopMenus(menu.children)
        // 未配置重定向的菜单，默认配置重定向到第一个子菜单
        setRedirect(routeConfig)
        currentRoute.pop()
      }
      pathStack.pop()
    })
  }
  // 递归遍历菜单生成路由配置
  loopMenus(info.menus)
  return {
    path: base,
    component: {
      render(h) {
        return h(RouterView)
      },
    },
    children: route,
  }
}
// 命中缓存
function hitCache(keys, cachedInfoObj) {
  const cachedInfoKeys = Object.keys(cachedInfoObj)
  // 筛选差异项
  const diffKeys = keys.filter(key => !cachedInfoKeys.includes(key))
  const isHit = cachedInfoKeys.length > 0
  // 非低码页面可以直接走缓存
  const isLowcode = isLowcodePage()
  console.log('log => hitCache cachedInfoKeys', keys, diffKeys)
  return !isLowcode || isHit
}
// 判断最新数据和缓存数据是否相同
function isSame(newData, cachedData) {
  let isFlag = false
  // 循环遍历新旧对象，对比每个相同key的version
  for (const key in newData) {
    if (cachedData[key] && newData[key]) {
      if (cachedData[key].version === newData[key].version) {
        isFlag = true
      } else {
        isFlag = false
        console.log(
          'log => fuxi key is Not Same',
          key,
          cachedData[key].version,
          newData[key].version,
        )
        break
      }
    }
  }
  return isFlag
}

function isLowcodePage() {
  // 排除低码页面：低码标识为 /lowcode_ 或 /user-marketing (C用户营销不规范)
  // localhost没/v2 暂不考虑
  return (
    location.pathname.includes('/v2/lowcode_') || location.pathname.includes('/v2/user-marketing')
  )
}
